import { GoogleIcon, MicrosoftIcon } from 'components/atoms/Icons'
import { LoginButton } from './LoginButton'
import { useSupabaseClient } from '@supabase/auth-helpers-react'
import { Provider } from '@supabase/supabase-js'
import { ClientSideBackendError } from 'providers/CustomQueryClientProvider'
import { useMutation } from '@tanstack/react-query'

export const SocialLoginButtons = () => {
  const supabase = useSupabaseClient()

  const { mutate: signIn } = useMutation({
    mutationFn: async (provider: Provider) => {
      const { error } = await supabase.auth.signInWithOAuth({
        provider,
      })
      if (!error) return

      throw new ClientSideBackendError(`logging using ${provider.toString()}`, error)
    },
  })

  return (
    <>
      <LoginButton icon={<GoogleIcon />} view="secondary" onClick={() => signIn('google')}>
        Continue with Google
      </LoginButton>
      <LoginButton icon={<MicrosoftIcon />} view="secondary" onClick={() => signIn('azure')}>
        Continue with Microsoft
      </LoginButton>
    </>
  )
}
